export const items = [
  {
    id: "0",
    postDate: new Date("02/25/2020").toString(),
    postTitle: "Planning for Let There Be Light Begins",
    postText: `   I had wanted to make a game with strong Catholic and Christian themes for a long time. It was why 
        I decided to learn how to write code. After spending the weekend at a retreat held by the Newman 
        Center at Illinois State University, I was fired up and decided it was time to start working toward that 
        goal. I sat down with my Legend of Zelda notebook and started to brainstorm. Since I had spent the 
        weekend trying to grow closer to God, that's mainly what was on my mind during this brainstorm. I 
        actually came up with the name, "Let There Be Light" first. The idea that followed was an 
        exploration based platformer with no combat. The setting would have been very dark and the game 
        would have been about using light to dispel the darkness so the player could find their way to 
        heaven. The light the player would have used would have been a symbol for God leading the player in the right direction.
                    `,
    postImage: "",
    postYoutube: "",
    postLocalVid: "",
    postWidth: "",
  },
  {
    id: "1",
    postDate: new Date("03/01/2020").toString(),
    postTitle: "Development Begins",
    postText: `I had an idea and some motivation! I got right to work and began making my prototype. I grabbed 
    this png online and made him move and crafted an area to walk around in. I created objects that 
    would trigger shortcuts to open. And lastly, a light. As I walked around trying to think of how this
    game would work, I realized that this was not very exciting and quickly became boring. So, I went 
    back to the drawing board. I started thinking about what I wanted this game to accomplish and I 
    settled on two main points. 
    
    1.) I wanted to expose the Catholic faith to the world. It is something that is often misunderstood 
        and something that I felt I had to hide for most of my life. I hoped that if more media with Catholic 
        themes and imagery existed, then people would be more accepting of it. This point would inspire a 
        lot of the art and setting of the game. 
        
    2.) I wanted share some of the lessons I have learned while pursuing my faith. One of the strongest 
        lessons I've learned is the importance of being able to recognize your own weakness and rely on 
        your community to lift you up. Though, I've always been a bit solitary, so it was always much 
        easier for me to look to heaven for assistance. I wanted to reflect this in the main character. 
        
    My first thought was to have the source of his power be directly from God, but I didn't love this idea. 
    I wanted God's involvement to be more subtle. That's when I thought about the saints. I knew very 
    little about them, but had been hearing about them more and more while being at the Newman 
    Center. Involving them in this way would give me more of a reason to get to know them more, which 
    was something I wanted to do. So, I had a main character in pursuit of heaven. He was powerless 
    on his own, but had the saints, who were very devoted to God, to assist him on his journey. I was 
    really liking this idea and it was what I ended up sticking with.`,
    postImage: require("@/Resources/Images/OldPlayer.png"),
    postYoutube: "",
    postLocalVid: "",
    postWidth: "300",
  },
  {
    id: "2",
    postDate: new Date("01/31/2021").toString(),
    postTitle: "Gospels And Games Created",
    postText: `Almost a full year later, the game had made quite a bit of progress. I had some enemies and some 
    basic functionality, but working consistently on the game had proved a much bigger challenge than 
    I was expecting. A youtuber by the name of "DevDuck" had mentioned that showing his game off to 
    people and receiving feedback was a big motivator for him. So, I thought I would give it a try. I 
    wanted to try and create dev-log youtube videos. I hoped that having that responsibility would help
    me to develop a schedule and stick to it. I also knew that social media was a great way for 
    developers to start up a fan base. So, I sat down at my computer and started my youtube channel. I 
    chose the name "Gospels and Games" because I knew my channel would be touching on both 
    gaming and religious topics. Soon after, I began working on my very first dev-log video.`,
    postImage: "",
    postYoutube: "",
    postLocalVid: "",
    postWidth: "",
  },
  {
    id: "3",
    postDate: new Date("02/07/2021").toString(),
    postTitle: "Dev-Log #1 - Running and Jumping",
    postText: `After a week of hard work, I had my first dev-log. I was really proud of it and received a lot of 
    positive feed back. I even got some feedback from one of my favorite youtubers, DevDuck! The youtube channel definitely motivated me to work on the game. However, now it was time to get started on the next one, and I was drained of energy`,
    postImage: "",
    postYoutube: "https://www.youtube.com/embed/4PjXHddFKxU",
    postLocalVid: "",
    postWidth: "750",
  },
  {
    id: "4",
    postDate: new Date("07/02/2021").toString(),
    postTitle: "Dev-Log #2 - Bug Fixing",
    postText: `Now that I was a youtuber, making youtube videos became part of "Let There Be Light's" 
    development. The increased workload became overwhelming. On top of school and my 
    responsibilities at the Newman Center, it was too much and I had to put development on hold. Once 
    summer started and I was getting comfortable at my internship, I felt I had the time to try 
    development and youtube again. The game was in a pretty buggy state. If I was going to start 
    showing the game weekly, I thought it would be a good idea to clean some of these up. Development in general would also just be more enjoyable after the bugs were taken care of.`,
    postImage: "",
    postYoutube: "https://www.youtube.com/embed/EyMRS8oPh_s",
    postLocalVid: "",
    postWidth: "750",
  },
  {
    id: "5",
    postDate: new Date("07/30/2021").toString(),
    postTitle: "Dev-Log #3 - Re-thinking the code",
    postText: `My code for this game is pretty messy and unorganized. After being exposed to business level 
    code, this was painfully clear. I spent a month trying to clean up my code and improve it. I didn't 
    make too many changes, but I did find a new way to handle the player's animations, which would 
    make them all much easier to manage and debug. In this video, I implemented something that was entirely new to me.`,
    postImage: "",
    postYoutube: "https://www.youtube.com/embed/HTLLBEzT3Xs",
    postLocalVid: "",
    postWidth: "750",
  },
  {
    id: "6",
    postDate: new Date("08/27/2021").toString(),
    postTitle: "Dev-Log #4 - Attack Animations!",
    postText: `Finally, it was time to replace the Mega-Man bullet that had been my placeholder attack since nearly 
    the very beginning. In this video I created a three hit combo for St. Michael's neutral input. I was very 
    please with how it turned out. Oh yeah, and I had just graduated during the creation of this video.`,
    postImage: "",
    postYoutube: "https://www.youtube.com/embed/uhszaYs9O3g",
    postLocalVid: "",
    postWidth: "750",
  },
  {
    id: "7",
    postDate: new Date("11/01/2021").toString(),
    postTitle: "Transition From Student to Developer",
    postText: `No longer was I a student. No longer was I an intern. On this date, I started my first full-time 
    position as a programmer. It felt good to have not have to worry about homework when I got home 
    at the end of the day. However, until this point, I had still been attending almost every weekly 
    event at the Newman Center on campus. Following the same schedule that I followed when I was 
    still a student. This, by no means, was a bad way to spend time. As I have said before, it is very 
    important to have a supporting community. However, I needed to dedicate a lot more time to 
    development if I wanted to accomplish anything. So, I began distancing myself from the place and 
    community that played a very vital role in forming who I am today. It was tough, but it was a good 
    decision. On average, I had been spending about 14 hours there every week. I still had good 
    supporting friends who I see regularly, but I also now had time to work both on projects and myself. `,
    postImage: "",
    postYoutube: "",
    postLocalVid: "",
    postWidth: "",
  },
  {
    id: "8",
    postDate: new Date("12/01/2021").toString(),
    postTitle: "Shaping Up and Beginning Work on WestonBridson.com",
    postText: `
    For the first time in years, I was not relying on the structure of the Newman Center to decide how I 
    used my time. It was up to me to create my own structure, and it was harder than I expected. At 
    first, when I got home from work, I defaulted to my favorite pass times. I played video games and 
    watched youtube videos basically all night until I had to go to sleep. This went on for a time, 
    until I finally took a look at myself and realized that I was living the way that I did in high 
    school. I had pretty much set all of the disciplines that the Newman Center taught me to the side, 
    which was not what I had left the Center to do. 
    
    So, I sat down to plan out a weekly routine for myself that would include exercise, rest, development 
    time, and prayer. I had attempted to do this many times in the past, but I failed to find a routine 
    that I could keep up, while also sticking to the Newman Center's schedule. Now, I did not have that 
    problem. I finally came up with a healthy routine that I could sustain. It wasn't perfect, but it got me 
    started on this website. I didn't want to jump straight back into "Let There Be Light." That project is 
    large and can easily be overwhelming. I thought it would be best to develop this routine with a 
    smaller project before I jump back in. Besides, WestonBridson.com is something I had been wanting to do for a long time. `,
    postImage: "",
    postYoutube: "",
    postLocalVid: "",
    postWidth: "",
  },
  {
    id: "9",
    postDate: new Date("01/20/2022").toString(),
    postTitle: "All Caught Up",
    postText: `The previous posts are written in the past tense because I have been writing them during this past 
    week, documenting what has happened since the beginning from memory, using my available 
    resources to make the dates as accurate as possible. This post is being written on the date above, 
    January 20th of 2022, and future posts will be written on their respective dates. This page will be a 
    complete Dev-Log. Here I will share both videos of my work, but also my thoughts and struggles as 
    a developer. At this time, the website is nearing completion. My new routine is tiring, but it seems to 
    be working well as long as I stick to it. I definitely feel ready to jump back into development of "Let 
    There Be Light," but it may be another few months before I am posting videos again. My current 
    apartment is very small and crammed. As a result, finding good shots is difficult and stressful. My 
    lease ends in May. I may wait until I have a nicer set up to get back into youtube.`,
    postImage: "",
    postYoutube: "",
    postLocalVid: "",
    postWidth: "",
  },
  {
    id: "10",
    postDate: new Date("04/05/2022").toString(),
    postTitle: "Website Done And I'm Rested Up",
    postText: `Not long after my last post, I showed my website to my co-worker, who has much more experience 
    than me in web development. He pointed out a lot of issues with the design of my site. I both 
    appreciated and loathed the criticisms. It extended the development time of the website by about 
    3-4 weeks, but I am much happier with the end result than I would have been without his guidance. So I am definitely thankful for his help. 
    
    I finished the site some time in February. As stated before, I originally planned on starting to work 
    on "Let There Be Light" again, but decided it would be better to wait until I move into my new 
    apartment in May. I decided that I would take a week off and then begin some online courses 
    on game development. "Why the courses," you might ask? Well, for my job, the company I work for 
    bought me a course on Udemy for a framework called VueJS. This course was 80 hours and gave 
    me a great foundation for the framework. Any foundation I have for game development has come 
    from random youtube videos that did not build off of each other very well. Any foundation I 
    currently have in game development is covered with cracks. I want to fill those cracks so I can be more confident in my abilities. 
    
    Unfortunately, before I got started on those courses, I fell into another deep slump. My routine 
    suffered, my prayer life suffered, my motivation suffered. This is exactly the reason why I decided to 
    ease back into development with a smaller project. During the slump, I became frustrated with 
    myself for entering this state of low energy again. It happens way too often and I needed to figure 
    out why and deal with it. But of course, I was in the middle of a slump, so I didn't have much energy 
    to do that. For the next month and half or so, I spent 90% of my free time just playing games. I 
    enjoyed that time at least, but I wasn't happy with how compulsively I was playing them.
    
    In the last few weeks, I started re-connecting with some friends I haven't seen in a long time, and 
    making more of an effort to check-in with those I am close with. This definitely helped me to break 
    out of the slump. After spending some time self reflecting and speaking with a local priest, I 
    decided that I should just try to be more social. These slumps seem to start with me getting sucked 
    into a game and realizing how fun and easy it is to just sit in front of my computer and not worry 
    about anything else. I hoped that by making more of an effort to be around friends and family, I 
    would be less likely to let myself be so isolated. The priest didn't discount this idea, but was wise 
    enough to see that I might struggle with actually making that happen. I have always been more 
    antisocial, and it doesn't take too much social activity to run my batteries dry. He then suggested 
    that I get a dog. I laughed at first because I didn't expect that answer from a priest, but it actually 
    made a lot of sense. He explained that it wouldn't require much social energy, but it would require 
    me to focus on it throughout the day. I wouldn't be able to totally isolate myself with this creature
    relying on me for food and exercise. And, I can't say this was the first time I had considered getting 
    a dog in recent months. The life of an antisocial full-time web-developer, part-time game-developer, 
    passionate video gamer can easily get pretty lonely. Normally my connection with God has always 
    gotten me through that feeling, but there are less people in my life now than there ever has been 
    before. A dog might be the perfect answer to that problem.
    
    I haven't made any decisions yet, and there are other expenses that I need to take care of before I 
    even start looking at what I would need to take care of a dog. But I wanted to update you all on what 
    had been going on in my life and let you know that I still plan on returning to video making in May. I 
    would really like to be able to work consistently on "Let There Be Light," and make regular dev-log 
    videos on Youtube. But, in order for that to happen I have to identify and remove the obstacles that 
    have caused me to stop in the past. So, I apologize for the wait, but I believe it will pay off in the 
    long run. Thank you all for your patience and continued encouragement!`,
    postImage: "",
    postYoutube: "",
    postLocalVid: "",
    postWidth: "",
  },
  {
    id: "11",
    postDate: new Date("012/31/2022").toString(),
    postTitle: "New Years Eve Update!",
    postText: `Happy New Years! 
    A lot has happend in the last year. Some of it overwhelming, but there were plenty of happy memories
    aswell. I'm definitely looking forward to 2023 though! I've done a lot of work to make development less 
    stressful and to keep my mental health in a better state. One of the biggest changes to my life is that I 
    am a proud dog owner now! That decision took me away from development completely for a time 
    (besides development for my job), but now that I have a routine down, I am feeling very motivated to work on "Let There Be Light."`,
    postImage: "",
    postYoutube: "https://www.youtube.com/embed/Rq3W4-u-Lbs?si=xerd9YAw5d55jM92",
    postLocalVid: "",
    postWidth: "750",
  },
  {
    id: "12",
    postDate: new Date("09/06/2023").toString(),
    postTitle: "Let There Be Light is Complete",
    postText: `This time around, I really struggled to get back into development. After some pretty deep reflection 
    on the topic, I learned that I no longer really cared for the game that I was creating. Let There Be Light was originally supposed to be a short and simple platformer. ` + 
    `The only purpose of this project was to introduce me to real indie game development and the challenges that come with it. It was never meant to be so complex. However, I was very ` + 
    `excited about finally creating something from scratch and bringing it to life. I remember talking frequently about it with my friends at the Newman Center. I did not notice how heavily ` +
    `I was allowing the game to be influenced by the ideas we were sharing. Over time the identity of the project got so skewed in both scale and direction that in some ways, it no ` +
    `longer felt like something I wanted to continue working on. 
    
    It was a tough decision, but it was time to move on from Let There Be Light. I had gotten the knowledge and experience that I needed from it and I was ready to work on something that I was ` +
    `more passionate about. However, I was still very proud of the work that I accomplished in this game. I am greatly pleased with how the character movement and attacks all turned out. ` +
    `It looked good, it felt good, and it was good. I thought it would be a bit of a shame to just toss it all aside, especially with a whole youtube series following its development. ` +
    `So, I decided to take what I had and mold it into a complete and playable experience. After all, a short and complete game would look better in a portfolio than another complex failed attempt.
    
    So, I decided to treat the rest of development the same way I treated my last game jam. Instead of asking "What features would benefit this game?" I asked "What features are absolutely necessary for release." ` +
    `My focus was much less on quality at this point and more on efficiency. Remember, this game is more of a stepping stone than a destination. So I decided to change the premise of this game from ` +
    `"2D Platformer Souls-like," to "2D Platformer Rouge-lite." This would allow me to make a small arena with randomly spawning enemies that could be reused, greatly decreasing development time. So I built the arena, ` +
    `a safe place for the player to manage his upgrades, spawning functionality for my enemies, a score system, and a wave system. Then I made an opening cutscene and tinkered with spawn rates and wave difficulty ` +
    `until I was happy with it. I play tested it extensively and even had some friend play test it. It was nowhere near perfect, but we all had a lot of fun. And that was an experience I have been looking forward too since I first started game development. There's a lot more I would've liked to add to the game, but it is simply time to move on. I am very proud of what I have made and very excited to see what the future holds. ` +
    ` 
    
    The game will be downloadable from the project's main page, which can be found on the home page. `,
    postImage: "",
    postYoutube: "",
    postLocalVid: "",
    postWidth: "",
}

];
